<template>
  <div :class="data.theme == '超体'? 'sup_style' : $attrs.type == 'daterange' ? 'hwork_daterange_style' : 'hwork_daterange_style'">
    <el-date-picker v-bind="$attrs" :class="[tetleTemp ,{'daterange_div':$attrs.type == 'daterange', 'daterange_div':$attrs.type != 'daterange'}]"
    ref="hDatePickerRef" id="hDatePickerDom" 
    :style="{
      '--minWeight':data.minWeight,
      '--px':data.px,
      '--leftWidth':data.leftWidth
	  }"
    @change="changeDatePickerHandler">
      <template #default>
          <slot name="default" />
      </template>
      <template #range-separator>
          <slot name="range-separator" />
      </template>
    </el-date-picker>
  </div>
</template>

<script>
  import { defineComponent } from 'vue';

  export default defineComponent({
    inheritAttrs: false,
    name: 'h-date-picker-new',
    props:['isShowTitle']
  });
</script>

<script setup>
import { getCurrentInstance, onMounted, ref, h, render, reactive, inject, onUpdated } from 'vue'
const { proxy, ctx } = getCurrentInstance()
const hDatePickerRef = ref()
// const props = defineProps({
//   title: String,
//   theme: String,
// });
const data = reactive({
  minWeight:'',
  name:'',
  hDatePickerTitle:null,
  px:'',
  title: inject("value"),
  theme: inject(proxy.md5("theme")),
})
// alert(data.title)
let tetleTemp = data.title && proxy.md5(data.title).replace(/[0-9]/g, '')
const changeDatePickerHandler = (e) => {
  console.log('changeDatePickerHandler',e)
}
const setMinWeightFun = () => {
  // if((proxy.$attrs.type == 'daterange' && data.theme == 'hwork')||isShowTitle){
    data.minWeight ='380px'
    titleLengthFun()
    addTitle() 
  // }else if(proxy.$attrs.type != 'daterange' && data.theme == 'hwork'){
  //   data.minWeight = '280px'
  //   titleLengthFun()
  //   otherAddTitle()
  // }else{
  //   data.px = 2 * 14 + 6 
  //   data.leftWidth = data.px + 24 + 16 + 12 + 'px'
  //   titleLengthFun()
  //   otherAddTitle()
  // }
}
const titleLengthFun = () => {
  data.px = data.title.length * 14 + 6
  data.leftWidth = data.px + 24 + 16 + 12 + 'px'
  data.px = data.px + 'px'
  console.log('321324',data.leftWidth)
}
const addTitle = () => {
  data.hDatePickerTitle = document.createElement('div')
  data.hDatePickerTitle.style.wordBreak = 'keep-all'
  data.hDatePickerTitle.id = 'hDatePickerTitle'
  data.hDatePickerTitle.className = 'title'
  let domF = document.querySelector('.'+ tetleTemp)
  let domC = domF.firstChild
  domF.insertBefore(data.hDatePickerTitle,domC)
  render(    
    <div style="word-break:keep-all;width:var(--px);display: inline-flex;padding-right:6px;">
      <div>{data.title}</div>
      <div>{proxy.$slots.left ? proxy.$slots.left() : ''}</div>
      <div>{proxy.$slots.right ? proxy.$slots.right() : ''}</div>
    </div>,
    data.hDatePickerTitle)
}
const otherAddTitle = () => {
  // el-input__prefix
  data.hDatePickerTitle = document.createElement('div')
  data.hDatePickerTitle.style.wordBreak = 'keep-all'
  data.hDatePickerTitle.id = 'hDatePickerTitle'
  data.hDatePickerTitle.className = 'title'
  let domF = document.querySelector('.'+ tetleTemp + ' span[class="el-input__prefix"]')
  console.log('domF',domF)
  let domC = domF.firstChild
  domF.insertBefore(data.hDatePickerTitle,domC)
  render(    
    <div style="word-break:keep-all;width:var(--px);display: inline-flex;padding-right:6px;">
      <div>{data.title}</div>
      <div>{proxy.$slots.left ? proxy.$slots.left() : ''}</div>
      <div>{proxy.$slots.right ? proxy.$slots.right() : ''}</div>
    </div>,
    data.hDatePickerTitle)
}
const showDateicon = () => {
  console.log('mouseleave')
  let domAddClass = document.getElementsByClassName('el-range__close-icon')
  domAddClass.forEach(element => {
    !element.className.includes('el-icon-date') &&  (element.className += ' el-icon-date')
  });
}
onMounted(()=>{
  setMinWeightFun() 
  addEventListener('mouseover',function(){
    // showDateicon()
  })
})
onUpdated(()=>{
  // showDateicon()
})
</script>

<style lang="scss">
.hwork_daterange_style{
  min-width: var(--minWeight);
  .daterange_div{
    display: flex;
    height: 32px;
    min-width: var(--minWeight);
    padding: 5px 12px;
    border-radius: 6px;
  }
  .title{
    line-height: 22px;
    font-size: 14px;
    color: #4E5969;
    padding-left: 8px;
  }
    .el-input__icon{
      line-height: 22px;
      margin-left: 12px;
    }
    .el-range-separator{
      line-height: 22px;
    }
    .el-range__icon::before{
      display: none;
    }
}
.hwork_other_style{
  min-width: var(--minWeight);
  .other_div{
    display: inline-block;  
    min-width: var(--minWeight);
  }
  .el-input__inner{
    padding-left: var(--leftWidth) !important;
    font-size:14px;
    border-radius: 6px;
  }
  .title{
    line-height: 22px;
    font-size: 14px;
    color: #4E5969;
    display: inline-block;
    padding: 5px 0px;
  }
  .el-input__icon{
    line-height: 22px;
    font-size: 14px;
  }
  .el-input__suffix{
  }
  .el-icon-date::before{
    display: none;
  }
}
</style>